// TOP LEVEL IMPORTS
import React from 'react';
// ANT
import Button from 'components/common/Button';
import Icon from 'components/common/Icon';
import notification from 'antd/lib/notification';

const BackButton = ({ onBack }) => (
  <div style={{ textAlign: 'center', marginTop: 25 }}>
    <a size="large" style={{ margiRight: 10, fontSize: 14 }} onClick={() => onBack()}>
      <Icon type="left" style={{ marginRight: 3 }} />
      GO BACK
    </a>
  </div>
);

const NextButton = ({ renderBackButton, getDisabledState, onNext }) => {
  let disabled = getDisabledState();
  return (
    <div>
      <Button disabled={disabled} className="contract-flow-btn" onClick={() => onNext()}>
        NEXT
      </Button>
      {renderBackButton()}
    </div>
  );
};

const SendButton = ({
  sending, onComplete, renderBackButton, getDisabledState,
}) => {
  let disabled = getDisabledState();
  return (
    <div>
      <Button
        loading={sending}
        disabled={disabled || sending}
        className="contract-flow-btn"
        onClick={() => onComplete()}
      >
        {!sending ? 'SEND INVOICE' : 'SENDING'}
      </Button>
      {renderBackButton()}
    </div>
  );
};

class FormButtons extends React.Component {
  renderBackButton = () => {
    if (this.props.currentPageHeader > 0) {
      return <BackButton onBack={this.onBack} />;
    }
  };

  getDisabledState = () => false;

  render() {
    if (this.props.currentPageHeader === 0 || this.props.currentPageHeader === 1) {
      return (
        <NextButton
          renderBackButton={this.props.renderBackButton}
          getDisabledState={this.getDisabledState}
          onNext={this.props.onNext}
        />
      );
    }

    return (
      <SendButton
        getDisabledState={this.getDisabledState}
        sending={this.props.sending}
        renderBackButton={this.props.renderBackButton}
        onComplete={this.props.onComplete}
      />
    );
  }
}

export default FormButtons;



// WEBPACK FOOTER //
// ./src/routes/invoice-create/FormButtons/index.js